import React from 'react';
import ReusableTabs from '../../pages/ReusableTabs';
import InspectionSummary from './InspectionSummary/InspectionSummary';
import NonConfermanceReport from './NonConfermanceReport';


const QualityInspectionSummary = () => {
    const tabs = [
        { label: 'Inspection Summary', component: <InspectionSummary /> },
        { label: 'Non Conformance Report', component: <NonConfermanceReport /> },
    ];

    return (
        <ReusableTabs
            tabs={tabs}
            defaultTab={0}
            panelStyles={{ padding: '16px' }}
        />
    );
};

export default QualityInspectionSummary;
